import { Auth } from 'aws-amplify';
import { getDomain } from './constants';

export const USER_API_GATEWAY_ENDPOINT_NAME = 'User-API-Gateway-Endpoint';
export const COURSE_LMS_GATEWAY_ENDPOINT_NAME = 'Course-LMS-Gateway-Endpoint';
export const JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME =
  'Job-Dashboard-V2-API-Gateway-Endpoint';
export const JOB_SCRAPING_API_NAME = 'Job-Scraping-API';

const JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT =
  process.env.REACT_APP_USER_API_GATEWAY_ENDPOINT ||
  'https://c3yd5bh60c.execute-api.ap-south-1.amazonaws.com';
const USER_API_GATEWAY_ENDPOINT =
  process.env.REACT_APP_USER_API_GATEWAY_ENDPOINT ||
  'https://c3yd5bh60c.execute-api.ap-south-1.amazonaws.com';
const COURSE_LMS_GATEWAY_ENDPOINT =
  process.env.REACT_APP_COURSE_LMS_API_GATEWAY_ENDPOINT ||
  'https://6c7jn568a0.execute-api.ap-south-1.amazonaws.com';

const AWS_REGION = process.env.REACT_APP_AWS_REGION || 'ap-south-1';

const USER_POOL_ID =
  process.env.REACT_APP_USER_POOL_ID || 'ap-south-1_2xDr5HmfJ';
const USER_POOL_WEB_CLIENT_ID =
  process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID || '715oetv9o2f4jugf6to7u87r0r';
const ENV = process.env.REACT_APP_ENV || 'dev';
const IDENTITY_POOL_ID =
  process.env.REACT_APP_IDENTITY_POOL_ID ||
  'ap-south-1:5ef56f79-cca8-4903-a118-94aa6caab07b';
const USER_POOL_OAUTH_DOMAIN =
  process.env.REACT_APP_USER_POOL_OAUTH_DOMAIN ||
  'id-dev-almabetter.auth.ap-south-1.amazoncognito.com';

const JOB_SCRAPING_API =
  process.env.REACT_APP_JOB_SCRAPING_API_URL ||
  'https://fu2et51li2.execute-api.ap-south-1.amazonaws.com';

const DOMAIN = getDomain() || 'http://localhost:3000';

const config = {
  Auth: {
    identityPoolId: IDENTITY_POOL_ID,
    region: AWS_REGION,
    userPoolId: USER_POOL_ID,
    userPoolWebClientId: USER_POOL_WEB_CLIENT_ID,
    oauth: {
      domain: USER_POOL_OAUTH_DOMAIN,
      scope: [
        'phone',
        'email',
        'profile',
        'openid',
        'aws.cognito.signin.user.admin',
      ],
      redirectSignIn: `${DOMAIN}/`,
      redirectSignOut: `${DOMAIN}/`,
      responseType: 'code',
    },
  },
  API: {
    endpoints: [
      {
        name: JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
        endpoint: JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT,
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          };
        },
      },
      {
        name: USER_API_GATEWAY_ENDPOINT_NAME,
        endpoint: USER_API_GATEWAY_ENDPOINT,
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          };
        },
      },
      {
        name: COURSE_LMS_GATEWAY_ENDPOINT_NAME,
        endpoint: COURSE_LMS_GATEWAY_ENDPOINT,
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          };
        },
      },
      {
        name: JOB_SCRAPING_API_NAME,
        endpoint: JOB_SCRAPING_API,
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          };
        },
      },
    ],
  },
  Storage: {
    AWSS3: {
      bucket: `ab-user-files-${ENV}`,
      region: AWS_REGION,
    },
  },
};

export const UPLOAD_BULK_QUES_TEMPLATE_URL = `https://ab-public-bucket-${ENV}.s3.ap-south-1.amazonaws.com/UploadBulkQuestionTemplate.csv`;

export default config;
